import React from 'react'

export default ({ children }) => {
  return <div className="header">{children}</div>
}
